module.exports = __webpack_public_path__ + "img/potentialcustomer_icon_grey.97ea86a6.svg";